
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InstanceTag',
  props: {
    instanceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      baseClass: 'epb-instance-tag',
    }
  },
})
